import React, { useEffect, useState, useRef } from "react";
import cookies from "js-cookie";

const DropdownMain = ({ userData }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [userAvatar, setUserAvatar] = useState("");
  const dropdownRef = useRef(null);

  const getInitials = (name) => {
    if (!name) return "U";
    let initialArray = name.trim().split(" ");
    if (initialArray.length > 2) {
      initialArray = initialArray.slice(0, 2);
    }
    return initialArray
      .map((part) => part[0])
      .join("")
      .toUpperCase();
  };

  const handleRedirectToDashboard = () => {
    window.location.href =
      process.env.REACT_APP_PUBLIC_TESTINGDASH_NAVBAR_ROUTE_URL || "#";
  };

  const getDomain = () => {
    const hostname = window.location.hostname;
    return hostname === "localhost"
      ? undefined
      : process.env.REACT_APP_PUBLIC_COMMON_PROD_URL;
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      const avatar = cookies.get("avatar");
      setUserAvatar(avatar);
    }
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const fullName = userData?.full_name || userData?.name || "user";
  const userEmail =
    userData?.email || userData?.user?.email || "user@domain.com";

  return (
    <div ref={dropdownRef} className="relative inline-block text-left">
      <div className="flex items-center gap-3">
        <span className="text-white text-base font-medium hidden md:inline-block">
          {fullName}
        </span>
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="flex items-center justify-center w-10 h-10 rounded-full border border-gray-700 overflow-hidden focus:outline-none hover:border-gray-500 transition-colors"
          aria-label="User menu"
        >
          {userData?.profile?.image?.file_path ? (
            <img
              src={
                process.env.REACT_APP_PUBLIC_BASE_URL +
                userData.profile.image.file_path
              }
              alt={fullName}
              className="w-full h-full object-cover"
            />
          ) : (
            <div
              className="flex items-center justify-center w-full h-full text-white font-bold"
              style={{
                backgroundColor: userAvatar ? userAvatar : "#e11d48",
              }}
            >
              <span className="text-sm">{getInitials(fullName)}</span>
            </div>
          )}
        </button>
      </div>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-56 rounded-md bg-[#171725] border border-gray-700 shadow-2xl p-2.5 z-50 text-white">
          {/* User Profile Info Header */}
          <div className="pb-2.5 border-b border-gray-700/80 px-1">
            <div className="text-base font-bold text-white truncate">
              {fullName}
            </div>
            <div className="text-xs text-gray-400 truncate mt-0.5">
              {userEmail}
            </div>
          </div>

          {/* Options */}
          <div className="pt-2 space-y-1">
            <button
              onClick={() => {
                setIsOpen(false);
                handleRedirectToDashboard();
              }}
              className="flex items-center w-full px-2.5 py-2 text-sm font-medium text-white rounded-md hover:bg-white/10 hover:border hover:border-gray-600 transition-all text-left border border-transparent gap-2.5"
            >
              {/* Dashboard Icon */}
              <svg
                className="w-4 h-4 text-gray-300"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <rect x="3" y="3" width="7" height="7" rx="1" />
                <rect x="14" y="3" width="7" height="7" rx="1" />
                <rect x="14" y="14" width="7" height="7" rx="1" />
                <rect x="3" y="14" width="7" height="7" rx="1" />
              </svg>
              <span>My Dashboard</span>
            </button>

            <div className="border-b border-gray-700/80 my-1" />

            <button
              onClick={() => {
                setIsOpen(false);
                cookies.remove("access", { domain: getDomain(), path: "/" });
                cookies.remove("planName", { domain: getDomain(), path: "/" });
                cookies.remove("refresh", { domain: getDomain(), path: "/" });
                cookies.remove("role", { domain: getDomain(), path: "/" });
                cookies.remove("userDetails", { domain: getDomain(), path: "/" });
                cookies.remove("avatar", { domain: getDomain(), path: "/" });
                window.location.href =
                  process.env.REACT_APP_PUBLIC_TESTINGLOGIN_NAVBAR_ROUTE_URL ||
                  "/login";
              }}
              className="flex items-center w-full px-2.5 py-2 text-sm font-medium text-rose-400 hover:text-rose-300 rounded-md hover:bg-rose-500/10 transition-all text-left gap-2.5"
            >
              {/* Logout Icon */}
              <svg
                className="w-4 h-4 text-rose-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                />
              </svg>
              <span>Logout</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DropdownMain;
